import React, { Component } from "react";

import ReactQuill from "react-quill";

import { Link } from "react-router-dom";

// eslint-disable-next-line no-unused-vars
import theme from "react-quill/dist/quill.snow.css";

import classnames from "classnames";

import { animateScroll } from "react-scroll";

import { pushDatatoServer } from "../../../../components/utils/RequestsHelper";

import PropTypes from "prop-types";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { transformIdentifier } from '../../../../utils/Utils';

const iconStyle = {
  float: "right"
};

const myStyle={
  padding: '0'
}

class FormLoja extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      description: "",
      local: "",
      identifier: "",
      mainPhoto: "",
      photos: [],
      phoneContacts: [],
      photo: "",
      contact: "",
      website: "",
      facebook: "",
      instagram: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addPhotoToArray = this.addPhotoToArray.bind(this);
    this.addContactToArray = this.addContactToArray.bind(this);
    this.validateData = this.validateData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mode === "Editar" && nextProps.data.name !== undefined) {
      let data = nextProps.data;

      this.setState({ name: data.name });
      this.setState({ description: data.description });
      this.setState({ local: data.local });
      this.setState({ website: data.website });
      this.setState({ identifier: data.identifier });
      this.setState({ mainPhoto: data.mainPhoto });
      this.setState({ photos: data.photos });
      this.setState({ phoneContacts: data.phoneContacts });
      this.setState({ facebook: data.facebook });
      this.setState({ instagram: data.instagram });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  addPhotoToArray() {
    let photo = this.state.photo;
    let photos = this.state.photos;

    photos.push(photo);
    this.setState({ photos });
    this.setState({ photo: "" });
  }

  addContactToArray() {
    let {contact, phoneContacts} = this.state;

    phoneContacts.push(contact);
    this.setState({phoneContacts});
    this.setState({contact: ''});
  }

  handleFieldsChanges = (value, field) => {
    this.setState({ [field]: value });
  };

  renderMandatoryMessage = field => {
    if (this.state[field] === true) {
      return <span className="alert-danger ml-6">Campo obrigatório</span>;
    }
  };

  renderIdentifierExists = () => {
    if (this.state.identifierExists === true) {
      return <span className="alert-danger ml-6">Identificador já existe</span>;
    }
  };

  deletePhotoArray = url => {
    //alert(url);

    let photosArray = this.state.photos;
    var index = photosArray.indexOf(url); // <-- Not supported in <IE9
    if (index !== -1) {
      photosArray.splice(index, 1);
    }
    this.setState({ photos: photosArray });
  };

  deleteContactosArray = contact => {
    let contactsArray = this.state.phoneContacts;
    const index = contactsArray.indexOf(contact);
    if (index !== -1) {
      contactsArray.splice(index, 1);
    }
    this.setState({phoneContacts: contactsArray});

  }

  render() {
    const modules = {
      toolbar: [
        ["bold", "italic", "underline", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        ["link", "image"]
      ]
    };

    const formats = [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "blockquote",
      "list",
      "bullet",
      "indent",
      "align",
      "link",
      "image"
    ];

    return (
      <div className="row">
        <div className="col-12">
          <p className="labels">
            Nome*{this.renderMandatoryMessage("nameMissing")}
          </p>
          <input
            className={classnames(
              "input-form",
              this.state.isNameValid === false ? "bad-form" : ""
            )}
            type="text"
            name="name"
            value={this.state.name}
            placeholder="Nome Loja"
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12">
          <div
            className={classnames(
              this.state.isDescriptionValid === false ? "bad-form-quill" : ""
            )}
          >
            <p className="labels">
              Descrição*{this.renderMandatoryMessage("descriptionMissing")}
            </p>
            <ReactQuill
              name="description"
              value={this.state.description}
              onChange={value => this.handleFieldsChanges(value, "description")}
              modules={modules}
              formats={formats}
              placeholder="Descrição"
            />
          </div>
        </div>

        <div className="col-12">
          <p className="labels">
            Local*{this.renderMandatoryMessage("localMissing")}
          </p>
          <input
            className={classnames(
              "input-form",
              this.state.isLocalValid === false ? "bad-form" : ""
            )}
            type="text"
            name="local"
            placeholder="Local da Loja"
            value={this.state.local}
            onChange={this.handleChange}
          />
        </div>
        
        <div style={myStyle} className="col-12">
        <div className="col-12 col-sm-6">
          <p className="labels">
            Link Logotipo / Foto Principal*{this.renderMandatoryMessage("mainPhotoMissing")}
          </p>
          <input 
            className={classnames(
              "input-form",
              this.state.isMainPhotoValid === false ? "bad-form" : ""
            )}
            type="text"
            name="mainPhoto"
            placeholder="URL Logotipo"
            value={this.state.mainPhoto}
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12 col-sm-6">
          {this.state.mainPhoto !== "" && (
            <div className="row">
              <div className="flex-image">
                <img alt="Logotipo" src={this.state.mainPhoto} />
              </div>
            </div>
          )}
        </div>
        </div>
        <div className="col-12">
          <p className="labels">
            Outras fotos*{this.renderMandatoryMessage("photosMissing")}
          </p>
          <input
            className={classnames(
              "input-form",
              this.state.isPhotosValid === false ? "bad-form" : ""
            )}
            type="text"
            name="photo"
            value={this.state.photo}
            placeholder="URL Fotos Secundárias"
            onChange={this.handleChange}
          />
          

          {this.state.photo === undefined || this.state.photo === '' ? 
            
            <button
              className="btn btn-outline-info"
              onClick={this.addPhotoToArray}
              disabled
            >
              Adicionar Foto Secundária
            </button>

            :

            <button
              className="btn btn-outline-info"
              onClick={this.addPhotoToArray}
            >
              Adicionar Foto Secundária
            </button>
          }

          <div className="row">
            {this.state.photos.map(
              function(url) {
                return (
                  <div className="flex-image-form">
                    <img alt="Foto Principal" src={url} key={url} />
                    <button
                      onClick={() => this.deletePhotoArray(url)}
                      className="btn btn-outline-danger btn-sm"
                    >
                      Apagar Foto
                    </button>
                  </div>
                );
              }.bind(this)
            )}
          </div>
        </div>

        <div className="col-12">
          <p className="labels second-array-input">
            Contactos Telefónicos
          </p>
          
          <div>
            <input
              className={classnames(
                "input-form",
                this.state.isContactosValid === false ? "bad-form" : ""
              )}
              type="text"
              name="contact"
              value={this.state.contact}
              placeholder="Contacto Telefónico"
              onChange={this.handleChange}
            />
            <button
              className="btn btn-outline-info"
              onClick={this.addContactToArray}
            >
              Adicionar Contacto
            </button>
          </div>
          
          {this.state.phoneContacts.length > 0 && (
            <div className="row second-array-input">
              <div className="col-12">
                <Table className="backoffice-table">
                  <TableHead className="table-header">
                    <TableRow>
                      <TableCell>Contacto Telefónico</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.phoneContacts.map(
                      function(contact) {
                        return (
                          <TableRow key={contact}>
                            <TableCell>{contact}</TableCell>
                            <TableCell>
                              <i
                                onClick={() => this.deleteContactosArray(contact)}
                                style={iconStyle}
                                className="fas fa-times"
                              />
                            </TableCell>
                          </TableRow>
                        );
                      }.bind(this)
                    )}
                  </TableBody>
                </Table>
              </div>
            </div>
          )}
        </div>

        <div className="col-12 col-sm-4">
          <p className="labels second-array-input">
            Facebook
          </p>
          <input
            className={classnames(
              "input-form",
            )}
            type="text"
            name="facebook"
            placeholder="www.facebook.com/sabugueiroserradaestrela"
            value={this.state.facebook}
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12 col-sm-4">
          <p className="labels second-array-input">
            Instagram
          </p>
          <input
            className={classnames(
              "input-form",
            )}
            type="text"
            name="instagram"
            placeholder="www.instagram.com/serradaestrela"
            value={this.state.instagram}
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12 col-sm-4">
          <p className="labels second-array-input">
            Website
          </p>
          <input
            className={classnames(
              "input-form",
            )}
            type="text"
            name="website"
            placeholder="Website da Loja"
            value={this.state.website}
            onChange={this.handleChange}
          />
        </div>

        <div className="col-12 submit-buttons">
          <button
            onClick={this.handleSubmit}
            className="backoffice-btn btn btn-outline-success"
          >
            {this.props.mode === "create" ? "Adicionar" : "Editar"}
          </button>

          <Link
            className="backoffice-btn btn btn-outline-danger"
            to={this.props.mode === "create" ? "/backoffice/lojas" : "/backoffice/lojas/"+this.state.identifier}
          >
            Cancelar
          </Link>
        </div>
      </div>
    );
  }

  handleSubmit() {
    console.log(this.state);
    let isFormValid = this.validateData();

    if (isFormValid) {
      let data = {
        name: this.state.name,
        description: this.state.description,
        local: this.state.local,
        identifier: this.props.mode === "create" ? transformIdentifier(this.state.name) : this.state.identifier,
        mainPhoto: this.state.mainPhoto,
        photos: this.state.photos,
        website: this.state.website,
        phoneContacts: this.state.phoneContacts,
        facebook: this.state.facebook,
        instagram: this.state.instagram,
      };

      this.saveLoja(data);
    } else {
      animateScroll.scrollToTop({ smooth: true, spy: true, duration: 1000 });
    }
  }

  saveLoja = async data => {
    let res = {};
    try {
      if (this.props.mode === "create") {
        res = await pushDatatoServer("/api/lojas", data, "post");
      } else {
        res = await pushDatatoServer(
          "/api/lojas/" + data.identifier,
          data,
          "put"
        );
      }

      if (
        res.response.data.errors !== undefined &&
        res.response.data.errors.length !== 0
      ) {
        const missingFields = res.response.data["errors"];

        for (let x = 0; x < missingFields.length; x++) {
          if (missingFields[x].param === "identifier") {
            this.setState({ identifierExists: true });
            this.setState({ isIdentifierValid: false });
            animateScroll.scrollToTop({
              smooth: true,
              spy: true,
              duration: 1000
            });
          }
        }
      } else {
        this.context.router.history.push("/backoffice/lojas");
      }
    } catch (err) {
      this.context.router.history.push("/backoffice/lojas");
    }
  };

  validateData = () => {
    let isFormValid = true;

    if (!this.validateField("name", "isNameValid")) {
      isFormValid = false;
    }

    if (!this.validateField("description", "isDescriptionValid")) {
      isFormValid = false;
    }

    if (!this.validateField("local", "isLocalValid")) {
      isFormValid = false;
    }

    if (!this.validateField("mainPhoto", "isMainPhotoValid")) {
      isFormValid = false;
    }

    if (this.state.photos === undefined || this.state.photos.length === 0) {
      this.setState({ photosMissing: true });
      this.setState({ isPhotosValid: false });
      isFormValid = false;
    } else {
      this.setState({ photosMissing: false });
      this.setState({ isPhotosValid: true });
    }
    return isFormValid;
  };

  validateField = (field, isValidValue) => {
    let newState = {};
    let isValid = true;
    let missingString = field + "Missing";

    if (
      this.state[field] === "" ||
      this.state[field] === undefined ||
      this.state[field].length === 0
    ) {
      this.setState({ [missingString]: true });
      isValid = false;
    } else {
      this.setState({ [missingString]: "" });
    }

    newState[isValidValue] = isValid;
    this.setState(newState);
    return isValid;
  };
}

export default FormLoja;
